import { COMPANY, NAV_LINKS, LOGO_URL } from "../data/mock";
import { ArrowUp } from "lucide-react";

export const Footer = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="relative" style={{ background: 'linear-gradient(180deg, #070e24, #050b1c)' }}>
      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(30,64,175,0.2), transparent)' }} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10 lg:gap-16">
          {/* Brand */}
          <div>
            <div className="logo-container-dark mb-5 w-fit">
              <img src={LOGO_URL} alt="Hevi Haul" className="h-10 w-auto object-contain" />
            </div>
            <p className="text-white/35 text-sm leading-relaxed max-w-xs">
              {COMPANY.tagline} — Proudly Serving Ontario & Cross-Border Since {COMPANY.since}.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white/80 font-bold text-xs uppercase tracking-[0.15em] mb-6">Quick Links</h4>
            <div className="space-y-3">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollTo(link.href)}
                  className="block text-white/35 hover:text-white/70 text-sm transition-colors duration-200"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white/80 font-bold text-xs uppercase tracking-[0.15em] mb-6">Contact</h4>
            <div className="space-y-3 text-sm">
              <a href={`mailto:${COMPANY.email}`} className="block text-white/35 hover:text-white/70 transition-colors duration-200">
                {COMPANY.email}
              </a>
              <a href={`mailto:${COMPANY.emailSecondary}`} className="block text-white/35 hover:text-white/70 transition-colors duration-200">
                {COMPANY.emailSecondary}
              </a>
              <a href={`tel:${COMPANY.phone}`} className="block text-white/35 hover:text-white/70 transition-colors duration-200">
                {COMPANY.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">
            © {new Date().getFullYear()} {COMPANY.name} All Rights Reserved. | {COMPANY.email}
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="w-9 h-9 rounded-xl bg-white/[0.05] hover:bg-white/[0.1] border border-white/[0.06] flex items-center justify-center transition-colors duration-200"
            aria-label="Scroll to top"
          >
            <ArrowUp size={16} className="text-white/40" />
          </button>
        </div>
      </div>
    </footer>
  );
};
